<template lang="pug">
.px-5
  v-row.pt-10(align="center")
    v-col
      h2.primary--text {{ $camelToString(relation.name) || $camelToString(entity.name) }}
    v-col
      g-btn.primary--text.float-right.ml-5(@click="addQuoteItem") {{$t('QuoteItem.addQuoteItem')}}
      g-btn.primary--text.float-right(@click.stop="dialog = true") {{$t('ServiceItem.createServiceItem')}}
      service-item-modal(
        :entity="$findEntity('ServiceItem')",
        @close="close",
        @closeAndLoadItems="closeAndLoadItems",
        v-bind="{ dialog }"
      )
  template(v-for="(quoteItem, i) in instance")
    template(v-if="isNotDeleted(quoteItem)")
      app-entity(
        :extra-data="extraData",
        :chips="false",
        @close="setAsDeleted($event, i)",
        @duplicate="duplicateQuoteItem($event, i)",
        :path="`${path}[${i}]`",
        :parentPath="`${path}`",
        :entity="$findEntity(relation.type)",
        fromList,
        :key="key+ '' + i",
        :elementIndex="i",
        :visibleIndex="findVisibleIndex(quoteItem)",
        v-bind="{ ...$attrs, parent, selectorOnly, showInfo, relation, isActive, modalInstance, handlingUnits, serviceItems }",
      )
        template(v-for="(_, slot) in $slots")
          template(:slot="slot")
            slot(:name="slot")
      extra-field-groups(:path="`${path}[${i}]`", v-bind="{ entity }")
</template>

<script>
import EntityMixin from '@/mixins';
import axios from 'axios';
import ServiceItemModal from "@/components/Quote/ServiceItemModal";

export default {
  mixins: [EntityMixin],
  components: {
    ServiceItemModal
  },
  props: ['entity', 'chips', 'relation', 'path', 'parent', 'extraData', 'parentInstance', 'selectorOnly', 'showInfo', 'isActive'],
  data: () => ({
    key: 0,
    handlingUnits: [],
    serviceItems: [],
    dialog: false
  }),
  filters: {
    fixed(val) {
      return Number.parseFloat(val).toFixed(2);
    },
  },
  methods: {
    async loadHandlingUnits() {
      try {
        const endpoint = this.$fetchLoad(`HandlingUnit?Where[]=h => h.Entity.Contains("QuoteItem") || h.Entity = null`, true)
        this.handlingUnits = (await axios.get(endpoint, { params: { pageSize: -1 }})).data.data;
      } catch (error) {
        console.log(this.$cleanString(error));
      }
    },
    async loadServiceItems() {
      try {
        const endpoint = this.$fetchLoad(`ServiceItem`, true)
        this.serviceItems = (await axios.get(endpoint, { params: { pageSize: -1 }})).data.data;
      } catch (error) {
        console.log(this.$cleanString(error));
      }
    },
    addQuoteItem() {
      if (this.instance === undefined)
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path , value: [] });
      this.instance.push({ uid: this.$generateUid(), entityState: 4, _Entity: 'QuoteItem', subtotal: 0 });
    },
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
    setAsDeleted (instance, i) {
      if (instance.id) {
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '['+i+'].entityState', value: 2 });
      } else {
        this.instance.splice(i, 1);
      }
      this.deleteQuoteItem(instance);
      this.key++;
    },
    duplicateQuoteItem(quoteItem, index) {
      const newQuoteItem = _.cloneDeep(quoteItem);
      newQuoteItem.extraData = !newQuoteItem.extraData ? [] : newQuoteItem.extraData.map(({ extraFieldId, type, value }) => ({ entityState: 4, extraFieldId, new: true, type, value }));
      this.instance.splice(index + 1, 0, { ...newQuoteItem, id: null, uid: this.$generateUid(), entityState: 4, _Entity: 'QuoteItem' });
      this.key++;
    },
    deleteQuoteItem({ uid }) {
      const newQuoteItems = _.reduce(this.instanceQuoteItems, (acc, content) => {
        if (content.uid != uid) return [...acc, content];
        if (content.entityState != 4) {
          return [...acc, { ...content, entityState: 2 }];
        }

        return acc;
      }, [])
      this.$store.commit('SET_INSTANCE_PATH', { path: 'quoteItems', value: newQuoteItems });
    },
    findVisibleIndex(quoteItem) {
      if (!this.visibleQuoteItems) return null;
      return this.visibleQuoteItems.findIndex(vp => {
        if (quoteItem.id) return vp.id === quoteItem.id
        return vp.uid === quoteItem.uid
      });
    },
    close() {
      this.dialog = false;
    },
    async closeAndLoadItems() {
      this.dialog = false;
      await this.loadServiceItems();  
    }
  },
  computed: {
    visibleQuoteItems() {
      return (this.instance || []).filter(this.isNotDeleted);
    },
    instanceQuoteItems() {
      return _.get(this.parentInstance, 'quoteItems', []);
    }
  },
  async created() {
    await this.loadHandlingUnits();
    await this.loadServiceItems();
  },
}
</script>
